import { render, staticRenderFns } from "./BiDisclosureModal.vue?vue&type=template&id=3a2299c5&"
import script from "./BiDisclosureModal.vue?vue&type=script&lang=ts&"
export * from "./BiDisclosureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports